<template>
  <app-icon-btn
    :access="canModifyTableRows(role)"
    :show-tooltip="!canModifyTableRows(role).allowed"
    img-class="inverted-icon"
    top
    @click="importLinkData">
    <template
      #img>
      <span
        class="small-p d-flex align-center"
        style="width:100%;">
        <img
          class="v-icon__dialog-icon"
          src="@/assets/icons/scraper-icon.svg"
          alt="import icon">
        Import data from link
      </span>
    </template>
  </app-icon-btn>
</template>
<script>
import { createPromiseDialog } from 'vue-promise-dialogs';
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ImportLinkDialog from '@/components/ProjectDetails/ProjectDetailsTableSchedule/TableActions/TableImportLink/ImportLinkDialog';
import { IMPORT_LINK_COLUMN } from '@/constants/productHeaders';

const openImportLinkDialog = createPromiseDialog(ImportLinkDialog);

export default {
  name: 'TableImportLink',
  props: {
    rowId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    IMPORT_LINK_COLUMN: IMPORT_LINK_COLUMN,
  }),
  computed: {
    ...mapState(['role']),
    ...mapState('ProjectDetailsTableSchedule', ['scheduleId']),
    ...mapGetters('UserRoles', ['canModifyTableRows']),
    ...mapGetters('ScheduleRows', ['rowById']),
  },
  methods: {
    ...mapMutations(['spinner', 'openSnackBar']),
    // ImportLinkDialog handles the URL input validation + calling the scraper.
    // We work with the response to update the row here.
    async importLinkData() {
      const rowId = this.rowId;
      if (!this.canModifyTableRows(this.role)?.allowed || !rowId) {
        return;
      }

      const scrapedProduct = await openImportLinkDialog();
      if (!scrapedProduct) return;

      const cleanedData = this.cleanImportLinkData(scrapedProduct);
      const importLinkValue = JSON.stringify(cleanedData);

      this.$emit('updateCell', {
        ev: {
          value: importLinkValue,
        },
        col: IMPORT_LINK_COLUMN,
        rowId: rowId,
        columnName: IMPORT_LINK_COLUMN,
        columnType: IMPORT_LINK_COLUMN,
        oldVal: this.getOldValuesForImportLink(cleanedData, rowId),
      });

      this.showImportingInfo(cleanedData);
    },
    // Clean empty values + format certain fields for row update
    cleanImportLinkData(value) {
      const cleaned = {
      };
      for (const [key, val] of Object.entries(value)) {
        if (this.isEmptyImportLinkValue(val)) {
          continue;
        }
        if (key == 'Image') {
          if (val.length) {
            cleaned[key] = [val[0].id];
          }
          continue;
        }
        cleaned[key] = val;
      }
      return cleaned;
    },
    isEmptyImportLinkValue(value) {
      if (value == null) return true;
      if (typeof value === 'string') return value.trim() === '';
      if (Array.isArray(value)) return value.length === 0;
      if (typeof value === 'object') return Object.keys(value).length === 0;
      return false;
    },
    getOldValuesForImportLink(importedData, rowId) {
      const currRow = this.rowById(rowId);
      const oldVals = {
      };
      for (const [key, _ignored] of Object.entries(importedData)) {
        if (key in currRow) {
          oldVals[key] = currRow[key];
        } else {
          oldVals[key] = '';
        }
      }
      return JSON.stringify(oldVals);
    },
    showImportingInfo(importedData) {
      this.spinner(true);

      let infoText = '';
      const keys = Object.keys(importedData);
      if (keys.length === 0) {
        infoText = '';
      } else if (keys.length <= 3) {
        infoText = keys.join(', ');
      } else {
        const visibleKeys = keys.slice(0, 3);
        const remainingCount = keys.length - visibleKeys.length;
        infoText = `${visibleKeys.join(', ')}, and ${remainingCount} more`;
      }
      this.openSnackBar({
        title: 'Filling Imported Data',
        text: infoText,
        timeout: 30000,
      });

      setTimeout(() => this.spinner(false), 3000);
    },
  },
};
</script>
